import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTranslation } from 'react-i18next';
import { ContainerVertical, StepperIconContainer, Title, StepperSection, colors, ButtonLink } from '@aftersale-next/ui';
import { useTimelineExpanded } from '../../hooks/use-timeline-expanded';
import { useTimelineLength } from '../../hooks/use-timeline-length';
export default function ShowMoreEvents() {
  var _useTimelineExpanded = useTimelineExpanded(),
      _useTimelineExpanded2 = _slicedToArray(_useTimelineExpanded, 2),
      expanded = _useTimelineExpanded2[0],
      setExpanded = _useTimelineExpanded2[1];

  var numberEvents = useTimelineLength();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (numberEvents <= 2) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs(StepperSection, {
    children: [/*#__PURE__*/_jsx(ContainerVertical, {
      align: "center",
      justify: "flex-start",
      padding: "9px 0 0 0",
      children: /*#__PURE__*/_jsx(StepperIconContainer, {
        color: expanded ? colors.lightGray : colors.green
      })
    }), /*#__PURE__*/_jsx(ContainerVertical, {
      align: "flex-start",
      padding: "0 0 0 20px",
      children: /*#__PURE__*/_jsx(ButtonLink, {
        "data-testid": "expand-timeline-button",
        type: "button",
        onClick: function onClick() {
          return setExpanded(!expanded);
        },
        children: /*#__PURE__*/_jsx(Title, {
          children: expanded ? t('SHOW_LESS') : t('SHOW_MORE', {
            events_length: numberEvents - 2
          })
        })
      })
    })]
  });
}